import { Callout } from "@blueprintjs/core"
import StaticSelector from "components/Atoms/StaticSelector"
import StringInput from "components/Atoms/StringInput"
import DynamicSelector from "components/Molecules/DynamicSelector"
import { SKUS } from "graphql/selector.queries.gql"
import useAuth from "hooks/useAuth"
import React, { useMemo, useState } from "react"
import CalloutButton from "./CalloutButton"
import HarvestGradeSelector from "./HarvestGradeSelector"
const HarvestGradeForm = ({ gradePrices, onRemove, onAdd, isPriceRange }) => {
  const [ahg, changeHarvestGrades] = useState([])

  const isAddDisabled = useMemo(() => {
    if (isPriceRange) {
      if (!ahg || ahg.length === 0) {
        return true
      } else {
        return ahg && ahg.length === gradePrices.length
      }
    } else {
      return true
    }
  }, [ahg, gradePrices, isPriceRange])

  const me = useAuth()
  const perUnitList = me?.user?.currentDepartment?.defaultPerUnit
  return (
    <>
      {gradePrices.map((gp, index) => {
        return (
          <div className="grid grid-cols-12 gap-4 mb-2" key={index}>
            <div className="col-span-12">
              <Callout className="relative pb-0">
                <div className="flex justify-end">
                  <CalloutButton
                    listLength={gradePrices.length}
                    disabled={isAddDisabled}
                    index={index}
                    path="gradePrices"
                    onRemove={onRemove}
                    onAdd={onAdd}
                    newObject={{
                      priceUnit: gp?.priceUnit || {},
                    }}
                  />
                </div>
                <div className="grid grid-cols-12 gap-4">
                  <div className="col-span-4">
                    <HarvestGradeSelector
                      onCompleted={data => {
                        changeHarvestGrades(data.referenceGrades)
                      }}
                      index={index}
                      gradePrices={gradePrices}
                      gradePrice={gp}
                    />
                  </div>
                  {isPriceRange ? (
                    <>
                      <div className="col-span-2">
                        <StringInput
                          type="number"
                          label="From"
                          path={`gradePrices.${index}.price`}
                          big={false}
                        />
                      </div>
                      <div className="col-span-2">
                        <StringInput
                          type="number"
                          label="To"
                          path={`gradePrices.${index}.priceLimit`}
                          big={false}
                        />
                      </div>
                    </>
                  ) : (
                    <div className="col-span-4">
                      <StringInput
                        type="number"
                        label="From"
                        path={`gradePrices.${index}.price`}
                        big={false}
                      />
                    </div>
                  )}
                  <div className="col-span-3">
                    {perUnitList?.length ? (
                      <StaticSelector
                        label="Per Unit"
                        items={perUnitList}
                        path={`gradePrices.${index}.priceUnit`}
                        big={false}
                      />
                    ) : (
                      <DynamicSelector
                        label="Per Unit"
                        query={SKUS}
                        path={`gradePrices.${index}.priceUnit`}
                        big={false}
                        variables={{
                          filter: {
                            metadata_Labels_Contains: ["vesatogo"],
                          },
                        }}
                      />
                    )}
                  </div>
                </div>
              </Callout>
            </div>
          </div>
        )
      })}
    </>
  )
}

export default HarvestGradeForm
